import { createReducer } from '../../utilities';

import { scope } from '../../../actions/app/support/user';
import {
    REQUEST_FETCH_USER,
    SUCCESS_FETCH_USER,
    FAIL_FETCH_USER,
    REQUEST_REMOVE_USER,
    SUCCESS_REMOVE_USER,
    FAIL_REMOVE_USER,
    REQUEST_FORCE_USER_PASSWORD,
    SUCCESS_FORCE_USER_PASSWORD,
    FAIL_FORCE_USER_PASSWORD,
    SUCCESS_UPDATE_USER,
    FAIL_UPDATE_USER, REQUEST_UPDATE_USER,
} from '../../../actions/entities/user';

const initialUserSupportState = {
    id: null,
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { id, payload, receivedAt, success } = action;
    return {
        ...state,
        id: id || state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload, type } = action;
    return {
        ...state,
        id: type === FAIL_FETCH_USER ? null : state.id,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialUserSupportState, {
    [REQUEST_FETCH_USER]: request,
    [SUCCESS_FETCH_USER]: success,
    [FAIL_FETCH_USER]: fail,

    [REQUEST_UPDATE_USER]: request,
    [SUCCESS_UPDATE_USER]: success,
    [FAIL_UPDATE_USER]: fail,

    [REQUEST_REMOVE_USER]: request,
    [SUCCESS_REMOVE_USER]: success,
    [FAIL_REMOVE_USER]: fail,

    [REQUEST_FORCE_USER_PASSWORD]: request,
    [SUCCESS_FORCE_USER_PASSWORD]: success,
    [FAIL_FORCE_USER_PASSWORD]: fail
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/support/user.js